import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import "./Info.scss";
import * as actionTypes from "../../store/Actions/actions";
import Reload from "../../assets/images/reloadApiWhite.svg";
import Popup from "../Modal/Popup";
import Axios from "../../axios";

class InfoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      description: this.props.description,
      meta_title: this.props.meta_title,
      saved: false,
      errorInSave: false,
      clickedSave: false,
    };
  }
  componentDidMount = () => {
    this.setState({
      title: this.props.title,
      description: this.props.description,
      meta_title: this.props.meta_title,
    });
    document.title =
      this.props.meta_title == null ? "Flimp Media" : this.props.meta_title;
  };
  componentWillUnmount = () => {};

  titleChange = (e) => {
    this.setState({
      title: e.target.value,
    });
  };
  descChange = (e) => {
    this.setState({
      description: e.target.value,
    });
  };
  meta_titleChange = (e) => {
    this.setState({
      meta_title: e.target.value,
    });
  };

  updateData = () => {
    let data = {
      u: this.props.userID,
      sn: this.props.sessionID,
      f: this.props.flimpID,
      title: this.state.title,
      desc: this.state.description,
      meta_title: this.state.meta_title,
    };

    if (this.state.title !== "" && this.state.description !== "") {
      this.setState({
        clickedSave: true,
      });
      Axios.MicrositeService.POST_MICROSITE_META_UPDATE(data).then((response) => {
        if (response.data.statusCode === "success") {
          this.setState(
            {
              saved: true,
              clickedSave: false,
            },
            () => {
              this.props.infoPushTitle(this.state.title);
              this.props.infoPushDesc(this.state.description);
              this.props.infoPushMetaTitle(this.state.meta_title);
              setTimeout(
                function () {
                  this.setState({ saved: false }, this.props.closeModal());
                }.bind(this),
                3000
              );
            }
          );
        }
        if (response.data.statusCode === "error") {
          this.setState({
            errorInSave: true,
          });
        }
      });
    }
  };
  render() {
    return (
      <Popup
        width="700"
        header="Portal Information"
        closePopup={this.props.closeModal}
        close={this.props.closeModal}
        animatedButton={
          <div className="footer">
            <button onClick={this.updateData} className="update boxShadowOnHover">
              {this.state.clickedSave ? <div className="loading"></div> : null}
              {this.state.saved ? (
                <div className="wrapperSaved">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 98.5 98.5"
                    enableBackground="new 0 0 98.5 98.5"
                  >
                    <path
                      className="checkmark"
                      fill="none"
                      strokeWidth="8"
                      strokeMiterlimit="10"
                      d="M81.7,17.8C73.5,9.3,62,4,49.2,4
	                    C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"
                    />
                  </svg>
                </div>
              ) : null}
              {this.state.errorInSave ? (
                <img className="reloadSave" src={Reload} />
              ) : null}
              {!this.state.clickedSave &&
              !this.state.saved &&
              !this.state.errorInSave ? (
                <span>Update</span>
              ) : null}
            </button>
            <button className="cancel boxShadowOnHover" onClick={this.props.closeModal}>
              Cancel
            </button>
          </div>
        }
      >
        <Fragment>
          <div className="content modalScrollContainer">
            <div className="form-group noGap">
              <label>Portal Title</label>
              <input
                value={this.state.title}
                placeholder="Update title"
                className={
                  "form-control" +
                  (this.state.title == "" ? " errorInputValidation" : " ")
                }
                onChange={this.titleChange}
              />
            </div>
            <div className="form-group noGap">
              <label>Brief Description</label>
              <textarea
                placeholder="Update description"
                className={
                  "form-control" +
                  (this.state.description == "" ? " errorInputValidation" : " ")
                }
                value={this.state.description}
                onChange={this.descChange}
              />
              <small>
                <strong>Note:</strong> The title and description are used to
                search and identify your content within the platform and
                distributions across communication channels, such as social
                media.
              </small>
            </div>
            <div className="form-group">
              <label>Title Tag (name displayed on the browser tab)</label>
              <input
                value={this.state.meta_title}
                placeholder="Update title"
                className="form-control"
                onChange={this.meta_titleChange}
              />
            </div>
          </div>
          <div className="clearfix"></div>
        </Fragment>
      </Popup>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
    title: state.present.title,
    description: state.present.description,
    meta_title: state.present.meta_title,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
    infoPushTitle: (infoTitle) => dispatch(actionTypes.infoTitle(infoTitle)),
    infoPushDesc: (infoDesc) => dispatch(actionTypes.infoDesc(infoDesc)),
    infoPushMetaTitle: (infoMeta_title) =>
      dispatch(actionTypes.infoMeta_title(infoMeta_title)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(InfoModal);
